import * as home from '../types/home'

export const initialState = {
    loading: false,
    products: [],
    error: null,
    bank: '',
    patModal: false,
    productModal: null,
    othersModal: false,
    aliRefModal: false
}

export const homeReducer = (state = initialState, action = { type: '' }) => {
    switch (action.type) {
        case home.OPEN_PRODUCT_MODAL:
            return {
                ...state,
                productModal: action.payload.group
            }
        case home.CLOSE_PRODUCT_MODAL:
            return {
                ...state,
                productModal: false
            }
        case home.OPEN_PRODUCT_ALI_REF_MODAL:
            return {
                ...state,
                aliRefModal: true
            }
        case home.CLOSE_PRODUCT_ALI_REF_MODAL:
            return {
                ...state,
                aliRefModal: false
            }
        case home.OPEN_PRODUCT_OTHERS_MODAL:
            return {
                ...state,
                othersModal: true
            }
        case home.CLOSE_PRODUCT_OTHERS_MODAL:
            return {
                ...state,
                othersModal: false
            }
        case home.OPEN_PAT_MODAL:
            return {
                ...state,
                patModal: true
            }
        case home.CLOSE_PAT_MODAL:
            return {
                ...state,
                patModal: false
            }
        case home.FETCH_PRODUCTS_SUCCESS:
            return {
                ...state,
                loading: false,
                products: action.payload.data
            }
        case home.FETCH_PRODUCTS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload.error
            }
        case home.FETCH_PRODUCTS_PENDING:
            return {
                ...initialState,
                loading: true
            }
        case home.FLIP_PRODUCT: {
            const index = state.products.findIndex(
                (p) => p.code === action.payload.code
            )
            return {
                ...state,
                products: [
                    ...state.products.slice(0, index),
                    {
                        ...state.products[index],
                        flipped: !state.products[index].flipped
                    },
                    ...state.products.slice(index + 1)
                ]
            }
        }
        case home.RESET:
            return initialState

        default:
            return state
    }
}
